import Vue from "vue";
import Router from "vue-router";

const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

import Home from "@/views/home/index";
import Middle from "@/views/middle/index";
import Search from "@/views/search/index";
import SearchMore from "@/views/search-more/index";
import CourseList from "@/views/course/list/index";
import CourseDetail from "@/views/course/detail/index";
import CourseColumn from "@/views/course/column/index";
import ArticleList from "@/views/article/list/index";
import ArticleColumn from "@/views/article/column/index";
import ArticleDetail from "@/views/article/detail/index";
import ShortVideoList from "@/views/short-video/list/index";
import ShortVideoDetail from "@/views/short-video/detail/index";
import LiveList from "@/views/live/list/index";
import LiveColumn from "@/views/live/column/index";
import LiveColumnList from "@/views/live/column_list/index";
import LiveColumnDetail from "@/views/live/column_detail/index";
import LiveDetail from "@/views/live/detail/index";
import LiveDetailHome from "@/views/live/detail_home/index";
import My from "@/views/my/index";
import MyAmount from "@/views/my/amount/index";
import AmountRule from "@/views/my/amount-rule/index";
import MyHistory from "@/views/my/history/index";
import MyFavorite from "@/views/my/favorite/index";
import MyListOrder from "@/views/my/list_order/index";
import MyService from "@/views/my/service/index";
import MySetting from "@/views/my/setting/index";
import MyUpdateTel from "@/views/my/update-tel/index";
import MySendVerify from "@/views/my/my-send-verify/index";
import Login from "@/views/login/login/index";
import YS from "@/views/login/ys/index";
import XY from "@/views/login/xy/index";
import SendVerify from "@/views/login/send-verify/index";
import AddInfo from "@/views/login/add-info/index";
import ChooseHospital from "@/views/login/choose-hospital/index";
import ChooseOffice from "@/views/login/choose-office/index";

//学知识
import KnowledgeCategory from "@/views/knowledge/category/index";
import KnowledgeList from "@/views/knowledge/list/index";
import KnowledgeDetail from "@/views/knowledge/detail/index";
//近期活动
import ActivityList from "@/views/activity/list/index";
import ActivityDetail from "@/views/activity/detail/index";
//就诊指南
import GuideList from "@/views/guide/list/index";
import GuideCategory from "@/views/guide/category/index";
import GuideDetail from "@/views/guide/detail/index";
//临床招募
import ClinicList from "@/views/clinic/list/index";
import ClinicDetail from "@/views/clinic/detail/index";
//公益救助
import CommunityList from "@/views/community/list/index";
import CommunityDetail from "@/views/community/detail/index";
import CommunityDetailNew from "@/views/community/new-detail/index";
import WhatWeDo from "@/views/community/what-we-do/index";
import Story from "@/views/community/story/index";
//诊断送检
import DiagnoseList from "@/views/diagnose/list/index";
import DiagnoseDetail from "@/views/diagnose/detail/index";
//互助圈
import ComradeList from "@/views/comrade/list/index";
import ComradeDetail from "@/views/comrade/detail/index";
//预约挂号
import InviteList from "@/views/invite/list/index";
import InviteDetail from "@/views/invite/detail/index";
//互助圈
import VideoColumn from "@/views/video/column/index";
import VideoDetail from "@/views/video/detail/index";

//公益专区
import welfareZone from "@/views/community/welfare-zone/index";
import Donation from "@/views/community/welfare-zone/donation/index";

// 医疗服务
import medicalServices from "@/views/medical-services/index";
import medicalServicesDetail from "@/views/medical-services/detail";

// 抗癌百科
import Anticancer from "./anticancer";
import Subject from "../views/subject";
import SubjectArticle from "@/views/subject/article";
import DoctorDetails from "@/views/doctor-details/index.vue";
import SearchNew from "@/views/search-new/index";

// 企微侧边栏
import CoUserDetail from "@/views/co_user_detail/index";
import Consul from "@/views/co_user_detail/consul";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      meta: {
        index: 0,
        title: "博医同行"
      },
      component: Home
    },
    {
      path: "/middle",
      name: "middle",
      meta: {
        index: 0,
        title: "博医同行"
      },
      component: Middle
    },
    {
      path: "/doctor-details/:id",
      name: "doctor-details",
      meta: {
        index: 0,
        title: "疑问医答"
      },
      component: DoctorDetails
    },
    {
      path: "/search-old",
      name: "search-old",
      meta: {
        index: 1,
        title: "搜索"
      },
      component: Search
    },
    {
      path: "/search-more",
      name: "search-more",
      meta: {
        index: 1,
        title: "搜索"
      },
      component: SearchMore
    },
    {
      path: "/course-list",
      name: "course-list",
      meta: {
        index: 1,
        title: "精品课程"
      },
      component: CourseList
    },
    {
      path: "/course-column/:id",
      name: "course-column",
      meta: {
        index: 2,
        title: "课程专栏"
      },
      component: CourseColumn
    },
    {
      path: "/course-detail/:id",
      name: "course-detail",
      meta: {
        index: 3,
        title: "课程详情"
      },
      component: CourseDetail
    },
    {
      path: "/article-list",
      name: "article-list",
      meta: {
        index: 1,
        title: "资讯"
      },
      component: ArticleList
    },
    {
      path: "/article-column/:id",
      name: "article-column",
      meta: {
        index: 1,
        title: "资讯专栏"
      },
      component: ArticleColumn
    },
    {
      path: "/article-detail/:id",
      name: "article-detail",
      meta: {
        index: 2,
        title: "资讯详情"
      },
      component: ArticleDetail
    },
    {
      path: "/short-video-list",
      name: "short-video-list",
      meta: {
        index: 1,
        title: "视频列表"
      },
      component: ShortVideoList
    },
    {
      path: "/short-video-detail/:id",
      name: "short-video-detail",
      meta: {
        index: 2,
        title: "相关视频推荐"
      },
      component: ShortVideoDetail
    },

    {
      path: "/live-list",
      name: "live-list",
      meta: {
        index: 1,
        title: "看直播"
      },
      component: LiveList
    },
    {
      path: "/live-column/:id",
      name: "live-column",
      meta: {
        index: 2,
        title: "专栏详情"
      },
      component: LiveColumn
    },
    {
      path: "/live-column-list",
      name: "live-column-list",
      meta: {
        index: 2,
        title: "专题直播"
      },
      component: LiveColumnList
    },
    {
      path: "/live-column-detail",
      name: "live-column-detail",
      meta: {
        index: 2,
        title: "直播专题详情"
      },
      component: LiveColumnDetail
    },
    {
      path: "/live-detail/:id",
      name: "live-detail",
      meta: {
        index: 2,
        title: "直播详情"
      },
      component: LiveDetail
    },
    {
      path: "/live-detail-home/:id",
      name: "live-detail-home",
      meta: {
        index: 2,
        title: "直播间"
      },
      component: LiveDetailHome
    },
    {
      path: "/live-detail-home/:id/:contentType",
      name: "live-detail-home",
      meta: {
        index: 2,
        title: "直播间"
      },
      component: LiveDetailHome
    },
    {
      path: "/my",
      name: "my",
      meta: {
        index: 0,
        title: "我的"
      },
      component: My
    },
    {
      path: "/my-history",
      name: "my-history",
      meta: {
        index: 1,
        title: "我的足迹"
      },
      component: MyHistory
    },
    {
      path: "/ys",
      name: "ys",
      meta: {
        index: 1,
        title: "博医同行隐私政策"
      },
      component: YS
    },
    {
      path: "/xy",
      name: "xy",
      meta: {
        index: 1,
        title: "博医同行用户使用协议"
      },
      component: XY
    },
    {
      path: "/my-amount",
      name: "my-amount",
      meta: {
        index: 1,
        title: "我的账户"
      },
      component: MyAmount
    },
    {
      path: "/amount-rule",
      name: "amount-rule",
      meta: {
        index: 2,
        title: "积分规则"
      },
      component: AmountRule
    },
    {
      path: "/my-favorite",
      name: "my-favorite",
      meta: {
        index: 1,
        title: "我的收藏"
      },
      component: MyFavorite
    },
    {
      path: "/my-list-order",
      name: "my-list-order",
      meta: {
        index: 1,
        title: "我的预约"
      },
      component: MyListOrder
    },
    {
      path: "/my-service",
      name: "my-service",
      meta: {
        index: 1,
        title: "联系客服"
      },
      component: MyService
    },
    {
      path: "/my-setting",
      name: "my-setting",
      meta: {
        index: 1,
        title: "设置"
      },
      component: MySetting
    },
    {
      path: "/my-update-tel",
      name: "my-update-tel",
      meta: {
        index: 2,
        title: "修改手机号"
      },
      component: MyUpdateTel
    },
    {
      path: "/my-send-verify",
      name: "my=send-verify",
      meta: {
        index: 3,
        title: "更改手机号"
      },
      component: MySendVerify
    },
    {
      path: "/login",
      name: "login",
      meta: {
        index: 5,
        title: "登录"
      },
      component: Login
    },
    {
      path: "/send-verify",
      name: "send-verify",
      meta: {
        index: 6,
        title: "发送验证码"
      },
      component: SendVerify
    },
    {
      path: "/add-info",
      name: "add-info",
      meta: {
        index: 7,
        title: "补充信息"
      },
      component: AddInfo
    },
    {
      path: "/choose-hospital",
      name: "choose-hospital",
      meta: {
        index: 8,
        title: "选择医院"
      },
      component: ChooseHospital
    },
    {
      path: "/choose-office",
      name: "choose-office",
      meta: {
        index: 8,
        title: "选择科室"
      },
      component: ChooseOffice
    },
    {
      path: "/knowledge-category",
      name: "knowledge-category",
      meta: {
        index: 2,
        title: "学知识"
      },
      component: KnowledgeCategory
    },
    {
      path: "/knowledge-list/:id",
      name: "knowledge-list",
      meta: {
        index: 2,
        title: "知识详情"
      },
      component: KnowledgeList
    },
    {
      path: "/knowledge-detail/:id",
      name: "knowledge-detail",
      meta: {
        index: 2,
        title: "知识详情"
      },
      component: KnowledgeDetail
    },

    //activity
    {
      path: "/activity-list",
      name: "activity-list",
      meta: {
        index: 1,
        title: "近期活动"
      },
      component: ActivityList
    },
    {
      path: "/activity-list-control/:year/:month",
      name: "activity-list-control",
      meta: {
        index: 1,
        title: "近期活动"
      },
      component: ActivityList
    },
    {
      path: "/activity-detail/:id",
      name: "activity-detail",
      meta: {
        index: 2,
        title: "活动详情"
      },
      component: ActivityDetail
    },

    //guide
    {
      path: "/guide-list",
      name: "guide-list",
      meta: {
        index: 1,
        title: "就诊指南"
      },
      component: GuideList
    },
    {
      path: "/guide-category/:category",
      name: "guide-category",
      meta: {
        index: 1,
        title: "就诊指南"
      },
      component: GuideCategory
    },
    {
      path: "/guide-detail/:id",
      name: "guide-detail",
      meta: {
        index: 2,
        title: "指南详情"
      },
      component: GuideDetail
    },

    //clinic
    {
      path: "/clinic-list",
      name: "clinic-list",
      meta: {
        index: 1,
        title: "临床招募"
      },
      component: ClinicList
    },
    {
      path: "/clinic-detail/:id",
      name: "clinic-detail",
      meta: {
        index: 2,
        title: "临床招募详情"
      },
      component: ClinicDetail
    },

    //clinic
    {
      path: "/community-list",
      name: "community-list",
      meta: {
        index: 1,
        title: "公益救助"
      },
      component: CommunityList
    },
    {
      path: "/community-detail/:id",
      name: "community-detail",
      meta: {
        index: 2,
        title: "公益详情"
      },
      component: CommunityDetail
    },
    {
      path: "/medical-assistance/:id",
      name: "community-detail-new",
      meta: {
        index: 2,
        title: "公益详情"
      },
      component: CommunityDetailNew
    },
    //diagnose
    {
      path: "/diagnose-list",
      name: "diagnose-list",
      meta: {
        index: 1,
        title: "诊断送检"
      },
      component: DiagnoseList
    },
    {
      path: "/diagnose-detail/:id",
      name: "diagnose-detail",
      meta: {
        index: 2,
        title: "诊断送检详情"
      },
      component: DiagnoseDetail
    },

    //comrade
    {
      path: "/comrade-list",
      name: "comrade-list",
      meta: {
        index: 1,
        title: "交流社区"
      },
      component: ComradeList
    },
    {
      path: "/comrade-detail/:id",
      name: "comrade-detail",
      meta: {
        index: 2,
        title: "战友故事"
      },
      component: ComradeDetail
    },

    //预约挂号
    {
      path: "/invite-list",
      name: "invite-list",
      meta: {
        index: 2,
        title: "预约挂号"
      },
      component: InviteList
    },
    {
      path: "/invite-detail",
      name: "invite-detail",
      meta: {
        index: 2,
        title: "预约挂号"
      },
      component: InviteDetail
    },
    {
      path: "/video-column/:id",
      name: "video-column",
      meta: {
        index: 1,
        title: "视频专栏"
      },
      component: VideoColumn
    },
    {
      path: "/video-detail/:id",
      name: "video-detail",
      meta: {
        index: 2,
        title: "视频详情"
      },
      component: VideoDetail
    },
    {
      path: "/welfare-zone",
      name: "welfare-zone",
      meta: {
        index: 1,
        title: "博医同行公益"
      },
      component: welfareZone
    },
    {
      path: "/donation",
      name: "donation",
      meta: {
        index: 2,
        title: "爱心集市-博医同行公益"
      },
      component: Donation
    },
    {
      path: "/what-we-do",
      name: "what-we-do",
      meta: {
        index: 2,
        title: "公益行动"
      },
      component: WhatWeDo
    },
    {
      path: "/story",
      name: "story",
      meta: {
        index: 2,
        title: "病友故事"
      },
      component: Story
    },
    {
      path: "/medical-assistance",
      name: "medical-assistance",
      meta: {
        index: 2,
        title: "救助项目"
      },
      component: CommunityList
    },
    {
      path: "/medical-services",
      name: "medical-services",
      meta: {
        index: 2,
        title: "医疗服务"
      },
      component: medicalServices
    },
    {
      path: "/medical-services-detail/:id",
      name: "medical-services-detail",
      meta: {
        index: 2,
        title: "医疗服务详情"
      },
      component: medicalServicesDetail
    },
    {
      path: "/topic-detail/:id",
      name: "topic-detail",
      meta: {
        index: 2,
        title: "专题"
      },
      component: Subject
    },
    {
      path: "/topic-article/:id/:topic/:i",
      name: "topic-article",
      meta: {
        index: 2,
        title: "专题"
      },
      component: SubjectArticle
    },
    {
      path: "/search",
      name: "search",
      meta: {
        index: 1,
        title: "搜索"
      },
      component: SearchNew
    },
    {
      path: "/co_user_detail",
      name: "co_user_detail",
      meta: {
        index: 1,
        title: "企微用户"
      },
      component: CoUserDetail
    },
    {
      path: "/gb_user_detail",
      name: "gb_user_detail",
      meta: {
        index: 1,
        title: "企微用户"
      },
      component: CoUserDetail
    },
    {
      path: "/consul",
      name: "consul",
      meta: {
        index: 2,
        title: "咨询详情"
      },
      component: Consul
    },
    // 抗癌百科
    ...Anticancer
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js